import { Button } from "react-bootstrap";

import * as api from "../../api/api";
import * as missionApi from "../../api/missionApi";
import { useUser } from "../../contexts/user_provider";
import StateIcon from "../StateIcon";

export default function ExportPartStatusMessage({
    mission,
    exportPart,
    exportState,
    missionHandlerStartRequested,
    setMissionHandlerStartRequested,
}) {
    const { getUserIsAdmin } = useUser();

    const formattedExportPart = exportPart
        ? exportPart.trim().replace(/^./, (c) => c.toUpperCase())
        : "Unknown";

    function cloudExportCanRestart(mission, exportPart) {
        return [
            missionApi.STATE_CANCELLED,
            missionApi.STATE_FAILED,
            missionApi.STATE_SUCCEEDED,
        ].includes(mission?.cloudExportStates?.[exportPart]);
    }

    const handleCloudExportRestart = async (e, exportPart) => {
        e.stopPropagation();
        try {
            await api.setCloudExportPending(
                mission.organizationId,
                mission.locationId,
                mission.id,
                exportPart,
            );
            if (!mission.running && !missionHandlerStartRequested) {
                setMissionHandlerStartRequested(true);

                await api.restartMissionHandler(
                    mission.organizationId,
                    mission.locationId,
                    mission.id,
                    {
                        restart: true,
                        onlyCloudExport: true,
                    },
                );
            }
        } catch (error) {
            console.error("Error restarting cloud export:", error);
        }
    };

    return (
        <div className="mt-1">
            {/* First row: Icon and App Name */}
            <div className="d-flex justify-content-between align-items-center">
                <div className="d-flex align-items-center">
                    <StateIcon state={exportState} className="me-3" />
                    <span className="ms-2" style={{ marginTop: "-2px" }}>
                        {formattedExportPart}
                    </span>
                </div>
                {getUserIsAdmin() &&
                    cloudExportCanRestart(mission, exportPart) && (
                        <Button
                            variant="outline-primary"
                            size="sm"
                            onClick={(e) => {
                                handleCloudExportRestart(e, exportPart);
                            }}
                            disabled={mission.running}
                        >
                            Restart
                        </Button>
                    )}
            </div>
        </div>
    );
}
